import React, { ReactElement, ForwardedRef } from 'react';
import UploadFile from '../upload-file/upload-file.component';

const FieldUpload: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const {
    isPlain,
    isDisabled,
    isImage,
    isInline,
    isLight,
    isNarrow,
    isMultiple,
    isRecursive,
    isDroppable,
    isListImage,
    isLargeImage,
    withDropOnly,
    withAllFilesAllowed,
    withDirectorySupport,
    withMultipleSelection,
    name,
    error,
    dropTargetBoxClassName,
    previewImageClassName,
    uploadFile,
    uploadFiles,
    defaultPreviewUrl,
    previewNameLimit,
    dropDeps,
    buttonLabel,
    acceptedExtensionList,
    inputRefs,
    inputRefIndex,
    onFileChange,
    onFileDelete,
    onFilesChange,
    onDirectoriesChange,
    onError,
    input,
    meta,
    ...custom
  } = props;

  const {
    touched: isTouched,
    invalid: isInvalid,
    error: formError,
    submitError: formSubmitError,
    modifiedSinceLastSubmit,
  } = (meta || {}) as FormFieldMetaProps;

  const withErrors: boolean = (isTouched && (!!formError || !!formSubmitError || !!error)) && !modifiedSinceLastSubmit;

  return (
    <UploadFile
      isLight={isLight}
      isImage={isImage}
      isInline={isInline}
      isNarrow={isNarrow}
      isDisabled={isDisabled}
      isMultiple={isMultiple}
      isRecursive={isRecursive}
      isDroppable={isDroppable}
      isListImage={isListImage}
      isLargeImage={isLargeImage}
      isInvalid={isTouched && (isInvalid || !!error)}
      withDropOnly={withDropOnly}
      withAllFilesAllowed={withAllFilesAllowed}
      withDirectorySupport={withDirectorySupport}
      withMultipleSelection={withMultipleSelection}
      ref={ref}
      error={withErrors && (formError || formSubmitError || error)}
      value={!isPlain ? (input && input.value) : null}
      fieldName={name}
      dropDeps={dropDeps}
      uploadFile={uploadFile}
      uploadFiles={uploadFiles}
      defaultPreviewUrl={defaultPreviewUrl}
      previewImageClassName={previewImageClassName}
      previewNameLimit={previewNameLimit}
      buttonLabel={buttonLabel}
      acceptedExtensionList={acceptedExtensionList}
      dropTargetBoxClassName={dropTargetBoxClassName}
      inputRefs={inputRefs}
      inputRefIndex={inputRefIndex}
      onFileChange={onFileChange}
      onFileDelete={onFileDelete}
      onFilesChange={onFilesChange}
      onDirectoriesChange={onDirectoriesChange}
      onError={onError}
      {...input}
      {...custom}
    />
  );
}));

export default FieldUpload;
